<template>
    <div class="row"> 
        <div class="col-sm-6">
            <div class="h-dialogContainer">
                <form id='measureCustomForm'>
                    <div class="row h-row-inputBox">
                        <div class="h-col-inputBox">
                            <div class="h-inputLit"><span class="h-red-code">*</span>{{$t('Pm.customCounterTypeId')}}:</div>
                            <div class="e-input-group e-control-wrapper">
                            <input class="e-control e-textbox e-lib e-input" name="customCounterTypeId" type="text" @blur="blurOfCustomCounterTypeId"  v-model="measureCustom.customCounterTypeId">
                            </div>
                        </div>
                    </div>
                    <div class="row h-row-inputBox">
                        <div class="h-col-inputBox">
                            <div class="h-inputLit"><span class="h-red-code">*</span>{{$t('Pm.customCounterTypeName')}}:</div>
                            <div class="e-input-group e-control-wrapper">
                            <input class="e-control e-textbox e-lib e-input" name="customCounterTypeName" type="text" v-model="measureCustom.customCounterTypeName">
                            </div>
                        </div>
                    </div>
                </form>
            </div>
        </div>
        <div class="col-sm-6">
            <div class="h-borderBox height-260 h-borderBox-height">
                <div class="h-borderTree-pm-content">
                    <div id="MeasureObjTree" class="tree-control-wrapper">
                        <ejs-treeview id='MeasureObjTreeForCreate' ref='MeasureObjTreeForCreate' :fields='fields' :showCheckBox='true'></ejs-treeview>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { CheckBoxSelection } from '@syncfusion/ej2-vue-dropdowns';
import { FormValidator } from "@syncfusion/ej2-vue-inputs";
import commonUtil from '../RealTimeTask/commonUtil';
import { EventBus } from "../../../../plugins/eventBus";
    
export default {
    name: 'AddMeasureCustom',
    components: {
        commonUtil
    },
    data() {
        return {
            neTypeId: null,
            formValidator: '',
            locale: localStorage.getItem('locale'),
            counterTypeIdList: [],
            measureCustom: {
                customCounterTypeId: 'C',
                customCounterTypeName: '',
            },
            fields: {
                dataSource: [{ children: [] }],
                id: 'id',
                child: 'children',
                expanded: 'state'
            },
            validateOptions: {
                customPlacement(inputElement, errorElement) {
                    errorElement.style.position = 'fixed';
                    inputElement.parentElement.parentElement.appendChild(errorElement);
                },
                rules: { 
                    'customCounterTypeId': {
                        required: [true, `${this.$t('Pm.customCounterTypeId')}`],
                    },
                    'customCounterTypeName': {
                        required: [true, `${this.$t('Pm.customCounterTypeName')}`],
                    },
                }
            }
        }
    },
    methods: {
        init(neTypeId){
            this.neTypeId = neTypeId;
            this.formValidator = new FormValidator('#measureCustomForm', this.validateOptions);
            this.$refs.MeasureObjTreeForCreate.uncheckAll();
            this.counterTypeIdList = [];
            this.getMeasureObjectTree();
        },
        blurOfCustomCounterTypeId(event) {
        const msg = event.target.value;
        if (msg != null && msg != '' && !msg.startsWith('C')) {
            this.measureCustom.customCounterTypeId = `C${msg}`;
        }
        },
        getMeasureObjectTree() {
            const params = {
                metertimeperiod: 2,
                neTypeId: this.neTypeId
            }
            this.$axios.get(`/lte/pm/measuretaskmanagement/getMeasureObjectTree.html${commonUtil.analyticParameter(params)}`).then((response) => {
                this.fields = {
                    dataSource: response.data,
                    id: 'id',
                    text: 'text',
                    child: 'children',
                    expanded: 'state'
                };
            });
        },
        validation() {
            let status = this.formValidator.validate();
            return status;
        },
        getMeasureCustomInfo() {
            if(!this.setCounterTypeIdList()){
                return null;
            }
            return {
                neTypeId: this.neTypeId,
                counterTypeIdList: this.counterTypeIdList,
                customCounterTypeId: this.measureCustom.customCounterTypeId,
                customCounterTypeName: this.measureCustom.customCounterTypeName,
            }
        },
        setCounterTypeIdList() {
            // 获取测量对象树中选中的测量对象节点信息
            let MeasureObjTreeForCreate = this.$refs.MeasureObjTreeForCreate;
            const checkNodesOfMeasureObjTree = MeasureObjTreeForCreate.getAllCheckedNodes();

            // 过滤树中的非网测量对象节点
            if (checkNodesOfMeasureObjTree.length == 0) {
                EventBus.$emit('toast', { type: 'warning', content: this.$t('Pm.selectMOplease') });
                return false;
            }

            for (let i = 0; i < checkNodesOfMeasureObjTree.length; i++) {
                // 获取选中节点信息
                const nodeChecked = MeasureObjTreeForCreate.getTreeData(checkNodesOfMeasureObjTree[i])[0];

                // 筛除掉父级非测量对象节点
                if (nodeChecked.children.length > 0) {
                    continue;
                }

                // 将选中的测量对象节点信息存入measureObj中

                // 将measureObj存入treeGridList中作为treeGrid的子节点
                this.counterTypeIdList.push(nodeChecked.id);
            }
            return true;
        }
    }
};
</script>

<style>
  .h-borderBox-height {
    border: 1px solid #d9d9d9;
    border-radius: 3px;
    height: 450px;
  }
</style>